/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { governanceMetricsGetApiV3GovernanceMetricsName } from "../../funcs/governanceMetricsGetApiV3GovernanceMetricsName.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3GovernanceMetricsNameRequest$inboundSchema,
};

export const tool$governanceMetricsGetApiV3GovernanceMetricsName:
  ToolDefinition<typeof args> = {
    name: "governance-metrics-get-api-v3-governance-metrics-name",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await governanceMetricsGetApiV3GovernanceMetricsName(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
